import { render } from "./Bookmark.vue?vue&type=template&id=441eb1f0&scoped=true"
import script from "./Bookmark.vue?vue&type=script&lang=js"
export * from "./Bookmark.vue?vue&type=script&lang=js"

import "./Bookmark.vue?vue&type=style&index=0&id=441eb1f0&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441eb1f0"],['__file',"webpack-assets/vue/templates/product/catalog/parts/Bookmark.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "441eb1f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('441eb1f0', __exports__)) {
    api.reload('441eb1f0', __exports__)
  }
  
  module.hot.accept("./Bookmark.vue?vue&type=template&id=441eb1f0&scoped=true", () => {
    api.rerender('441eb1f0', render)
  })

}


export default __exports__